"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = (function (_a) {
    var incoming = _a.incoming, choices = _a.choices, length = _a.length;
    var incomingIdx = choices.findIndex(function (variant) { return variant.id === incoming.id; });
    var uniqChoices = choices
        .filter(function (variant) { return variant.id !== incoming.id; })
        .reduce(function (arr, choice) {
        var idx = arr.findIndex(function (variant) { return variant.id === choice.id; });
        if (idx === -1) {
            arr.push(choice);
        }
        return arr;
    }, []);
    if (incomingIdx === -1) {
        uniqChoices.push(incoming);
    }
    if (uniqChoices.length === 0) {
        return [];
    }
    if (uniqChoices.length === length + 1) {
        return choices;
    }
    var allocation = [];
    for (var i = 0; i < length; i++) {
        allocation.push(uniqChoices[i % uniqChoices.length]);
    }
    return allocation;
});
